import Image from 'next/image';
import { useState } from 'react';
import { Icons } from '../icons';
import { useCurrentBranding } from '@/hooks/use-current-branding';

export function Logo() {
  const [branding] = useCurrentBranding();
  const [error, setError] = useState(false);
  if (branding?.branding?.images?.logo?.signed_url_get && !error) {
    return (
      <Image
        width={100}
        height={28}
        src={branding?.branding?.images?.logo?.signed_url_get}
        alt='Logo'
        onError={() => setError(true)}
        priority={true}
        className='h-7 object-contain'
      />
    );
  }
  return <Icons.logo height={28} />;
}
